<template>
    <sub-page class="m-addTrainPlan">
        <el-steps class="step-title" :active="active" finish-status="success" simple>
            <div class="click-zone" @click="toStep(0)"></div>
            <div class="click-zone" @click="toStep(1)"></div>
            <div class="click-zone" @click="toStep(2)"></div>
            <el-step :title="$t('train.basicInfo')" icon="nucfont inuc-edit-info" :status="step1Status"></el-step>
            <el-step :title="$t('train.trainees')" icon="nucfont inuc-members" :status="active===1?'process':''"></el-step>
            <el-step :title="$t('train.courseSystem')" icon="nucfont inuc-paper-step"></el-step>
        </el-steps>

        <!-- 第一步 -->
        <transition enter-active-class="animated fadeIn">
            <step-form ref="stepForm" v-show="active == 0" />
        </transition>

        <!-- 第二步 -->
        <transition enter-active-class="animated fadeIn">
            <step-member ref="stepMember" v-show="active == 1" />
        </transition>

        <!-- 第三步 -->
        <transition enter-active-class="animated fadeIn">
            <step-course ref="stepCourse" v-show="active == 2" />
        </transition>

        <div class="btn-group-affix">
            <el-button v-if="active === 0" type="primary" @click="toStep(1)" size="medium">{{ $t('c.next') }}</el-button>
            <el-button-group v-if="active === 1">
                <el-button @click="toStep(0)" size="medium">{{ $t('c.prev') }}</el-button>
                <el-button type="primary" @click="toStep(2)" size="medium">{{ $t('c.next') }}</el-button>
            </el-button-group>
            <el-button-group v-if="active === 2">
                <el-button @click="toStep(1)" size="medium">{{ $t('c.prev') }}</el-button>
                <el-button type="success" @click="submitTraining()" size="medium" :loading="submitLoading">
                    {{ $t('c.finish') }}
                </el-button>
            </el-button-group>
        </div>

        <!-- 草稿箱 -->
        <train-draft v-if="!planId && $i18n.locale === 'zh-CN'" @submit="onDraftRecover"></train-draft>

    </sub-page>

</template>

<script>
import api from '@/api';
import StepForm from "./StepForm";
import StepMember from "./StepMember";
import StepCourse from "./StepCourse";
import TrainDraft from "../Components/TrainDraft"

export default {
    name: 'addTrainPlan',
    props: ['planId'],
    components: {
        StepForm,
        StepMember,
        StepCourse,
        TrainDraft,
    },

    data() {
        return {
            active: 0,
            isFormValid: false,
        };
    },

    mounted() {
        if (this.planId) {
            this.initData();
        } else {
            this.queryMembers()
        }
    },

    computed: {
        step1Status() {
            if (this.active !== 0 && !this.isFormValid) {
                return 'error'
            }
        },
    },

    methods: {
        // 加载数据
        initData() {
            let q1 = this.queryMembers();

            let q2 = api.getTrainingDetail(this.planId).then(res => {
                //let data = res.package;
                this.fillData(res.package)
            })

            Promise.all([q1, q2]).then(() => {
                this.$refs.stepMember.updateSelectStatus()

                // XXX: 解决左侧列表无查询结果时在右表删除不会同步到左表的bug
                // 事实上只要对表格有操作就能解决这个bug，原因未知。。该代码有待商榷
                this.$nextTick(() => {
                    let $tr = $('.traineeTable').find('tbody tr:eq(0) td:eq(0) label')
                    $tr.click().click()
                })
            })
        },

        // 填充数据
        fillData(data) {
            // 加载第一步数据
            this.$refs.stepForm.fillData(data)

            // 加载第二步学员数据
            this.$refs.stepMember.fillData(data)

            // 加载第三部课件/考卷数据
            this.$refs.stepCourse.fillData(data)
        },

        toStep(e) {
            this.active = e;

            // 切换的时候做表单验证
            this.isFormValid = this.$refs.stepForm.validate()
        },

        queryMembers() {
            return this.$refs.stepMember.queryMembers()
        },

        getSubmitData() {
            let formData = this.$refs.stepForm.getData()

            let trainees = this.$refs.stepMember.getData()

            let processes = this.$refs.stepCourse.getData()

            return {
                ...formData,
                trainees,
                processes,
            }
        },

        submitTraining() {
            // 验证1：第一步的表单
            if (!this.isFormValid) {
                this.active = 0
                this.$message.error('请先完成基本信息的填写！')
                return;
            }

            // 验证2：环节为空
            let courseArray = this.$refs.stepCourse.courseArray
            if (!courseArray.length) {
                this.$message.error(this.$t('train.chooseTip'));
                return;
            }

            // 验证3：考卷未编辑
            let hasUndoneCourse = courseArray.some(val => (val.resType === 2 || val.resType === 3) && !val.extra.duration)
            if (hasUndoneCourse) {
                this.$message.error(this.$t('train.editPaperTip'));
                return;
            }


            let submitData = this.getSubmitData()

            this.submitLoading = true;

            if (this.planId) {

                api.editTraining(this.planId, submitData).then(res => {
                    this.$notify({
                        title: res.error,
                        message: this.$t('train.editSuccess'),
                        type: 'success',
                        duration: 2000
                    });

                    this.submitLoading = false;
                    this.$emit('onClose');
                    this.$router.replace({name: 'trainPlan'})
                }).catch(e => this.submitLoading = false);

            } else {

                api.postTraining(submitData).then(res => {
                    this.$notify({
                        title: res.error,
                        message: this.$t('train.addSuccess'),
                        type: 'success',
                        duration: 2000
                    });

                    this.submitLoading = false;
                    this.$emit('onClose');
                    this.$router.replace({name: 'trainPlan'})
                }).catch(e => this.submitLoading = false);
            }

        },

        onDraftRecover(data) {
            // 填充数据前先清空数据
            this.$refs.stepForm.clear()
            this.$refs.stepMember.clear()
            this.$refs.stepCourse.clear()

            this.fillData(data)
        }
    },
}
</script>

<style scoped lang="scss">
@import '~@/style/const';

@include scrollbar();

$panel-bg: #f5f7fa;

.step-title {
    position: relative;
    margin: -30px -20px 30px -20px;
    box-shadow: 0 1px 2px #ddd;
    @include media-1366 {
        margin: -15px -15px 30px -15px;
    }

    .click-zone {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 33%;
        cursor: pointer;
        z-index: 1;

        &:nth-of-type(2) {
            left: 33%;
        }

        &:nth-of-type(3) {
            left: 66%;
        }
    }
}

.btn-group-affix {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #eee;
    box-shadow: 0 2px 8px #ccc;
    z-index: 1;

    button {
        letter-spacing: 4px;

        + button {
            margin-left: 15px;
        }
    }
}

.el-select-dropdown__item {
    width: 470px;
}
</style>

<style lang="scss">
.m-addTrainPlan {

    > .el-main {
        overflow-x: hidden;
    }

    .el-step__head.is-process,
    .el-step__title.is-process {
        color: #22b9ff;
    }

    .el-step__head.is-wait,
    .el-step__title.is-wait {
        color: #a3a4a9;
    }

    .el-step__title.is-success,
    .el-step__head.is-success {
        color: #2e7faa;
    }

    .el-step__line {
        display: none;
    }

    .input-without-padding .el-input__inner {
        padding-right: 0;
    }

    .advanced-filter {
        .drawer {
            z-index: 3000;
        }
    }
}
</style>
